var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "tail-right"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M6.32715 2.07837L10.9489 6.36998L6.32715 10.6616",
    stroke: "white",
    strokeWidth: 1.65062,
    strokeLinecap: "square",
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    d: "M1.04688 6.19316H10.2903",
    stroke: "white",
    strokeWidth: 1.65062,
    strokeLinecap: "square",
    strokeLinejoin: "bevel"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRight);
export default __webpack_public_path__ + "static/media/right.d1d8c37446b900f56ca1e003f73d0c81.svg";
export { ForwardRef as ReactComponent };